'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsLink = require('@bibliocommons/utils-link');

var _reactRouter = require('react-router');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _BibTextSlide = require('./BibTextSlide.component');

var _BibTextSlide2 = _interopRequireDefault(_BibTextSlide);

require('../styles/SliderJacketCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderJacketCover = function SliderJacketCover(_ref) {
  var handleClick = _ref.handleClick,
      item = _ref.item,
      _ref$domain = _ref.domain,
      domain = _ref$domain === undefined ? '' : _ref$domain;
  return _react2.default.createElement(
    'div',
    { className: 'cp-slider-jacket-cover' },
    _react2.default.createElement(
      _reactRouter.Link,
      { key: item.id, onClick: handleClick, href: domain + '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.id), target: '_parent' },
      _react2.default.createElement(_sharedJacketCover2.default, { renderDefault: function renderDefault() {
          return null;
        }, format: item.format, src: item.jacket.medium, alt: '' }),
      _react2.default.createElement(_BibTextSlide2.default, { item: item })
    )
  );
};

SliderJacketCover.propTypes = {
  handleClick: _react2.default.PropTypes.func,
  domain: _react2.default.PropTypes.string,
  item: _react2.default.PropTypes.shape({
    id: _react.PropTypes.string.isRequired,
    format: _react.PropTypes.string.required,
    jacket: _react.PropTypes.shape({
      medium: _react.PropTypes.string.isRequired
    }).isRequired,
    title: _react.PropTypes.string.required
  })
};

exports.default = SliderJacketCover;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-slider-jacket-cover/lib/components/SliderJacketCover.component.js
// module id = 1507
// module chunks = 1